import React from 'react';
import PropTypes from 'prop-types';
import Accordion from 'react-bootstrap/Accordion';
import ReactMarkdown from 'react-markdown';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

const TermsAndConditions = ({ termsConditions }) => {
  const handelClick = (event) => {
    const elementToToggle = event.target;
    elementToToggle.classList.toggle('open');
  };

  return (
    <Container className="py-60">
      <Row className="justify-content-center pt-30 accordion-terms">
        <Col xs={12} md={12} lg={12} xl={12}>

          <Accordion className="text-left collapse show">
            <Card>
              <Accordion.Toggle
                as={Button}
                variant="link"
                eventKey="0"
                className="p-15 text-left not-link"
                onClick={handelClick}>
                <div className="font-weight-bold text-decoration-none ml justify-content-between text-tangaroa f-600">
                  Ver Términos y Condiciones
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="0" className="text-tangaroa">
                <Card.Body>
                  <ReactMarkdown>{ termsConditions }</ReactMarkdown>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Col>
      </Row>
    </Container>
  );
};

TermsAndConditions.propTypes = {
  termsConditions: PropTypes.string.isRequired,
};

export default TermsAndConditions;
